import React, { Fragment } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import AppMain from '../../Layout/AppMain';

class Main extends React.Component {
  render() {
    return (
      <Fragment>
        <AppMain />
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Main;
